import { IssueType } from "solar-bo";


export class IssueTypeHelper{
  /**
   * Returns the color for the issue type
   * @param issueType 
   */
  static issueGetErrorTypeColor(issueType: any): string {
    //
    const st = issueType;
    let res = "";
    if (st === IssueType.TOCXS) {
      res = "#000";
    } else if (st === IssueType.E1PC) {
      //hot spot
      res = "rgb(23,203,248)";      
    } else if (st === IssueType.PCS) {
      //multipleh hot spot
      res = "rgb(6,161 ,198)";  

    } else if (st === IssueType.E1CC) {
      //hot cell
      res = "rgb(250, 190, 0)";
      
    } else if (st === IssueType.CCS) {
      //several hot cells
      res = "rgb(196, 149, 0)";
    } else if (st === IssueType.SMC) {
      //hot cell string
      res = "rgb(248,24,221)";//"rgb(203, 204, 161)";
    } else if (st === IssueType.PID) {
      //
      res = "rgb(232, 81, 40)" ;//"rgb(255, 80, 80)";//res = "rgb(247, 198, 38)";
    } else if (st === IssueType.DRT) {
      res = "rgb(7, 101, 129)";
    } else if (st === IssueType.SDW) {
      res = "rgb(88,139,57)"; //"rgb(139, 139, 124)";
    } else if (st === IssueType.FUS) {
      res = "rgb(51, 204, 51)";
    } else if (st === IssueType.BRK) {
      res = "rgb(250, 0, 0)";
    } else if (st === IssueType.DSC) {
      res = "rgb(116, 44, 150)";
    } else if (st === IssueType.NDM) {
      res = "rgb(162, 238, 166)";
    } else if (st === IssueType.CBOX) {
      res = "rgb(0, 4, 250)";
    } else if (st === IssueType.IPO) {
      res = "rgb(250, 0, 217)";
    } else if (st === IssueType.DBB) {
      res = "rgb(250, 0, 217)";
    } else if (st === IssueType.DLM) {
      res = "rgb(250, 0, 217)";
    } else if (st === IssueType.SHC) {
      res = "rgb(100, 111, 156)";      
    } else if (st === IssueType.UNK) {
      res = "rgb(250, 0, 217)";
    } else {
      res = "#f44336";
    }

    return res;
  } 
  
    static issueGetErrorTypeDescription(issueType: any): string {
    //
    const st = issueType;
    let res = "";
    if (st === IssueType.TOCXS) {
      res = "All";
    } else if (st === IssueType.E1PC) {
      //hot spot
      res = "Hot Spot";      
    } else if (st === IssueType.PCS) {
      //multipleh hot spot
      res = "Several hot spots";  
    } else if (st === IssueType.E1CC) {
      //hot cell
      res = "Hot cell";
      
    } else if (st === IssueType.CCS) {
      //several hot cells
      res = "Several hot cells";
    } else if (st === IssueType.SMC) {
      //hot cell string
      res = "Bypass Diode";//"rgb(203, 204, 161)";
    } else if (st === IssueType.PID) {
      //
      res = "Potential induced degradation";//res = "rgb(247, 198, 38)";
    } else if (st === IssueType.DRT) {
      res = "Dirt";
    } else if (st === IssueType.SDW) {
      res = "Shadow"; //"rgb(139, 139, 124)";
    } else if (st === IssueType.FUS) {
      res = "Fuse";
    } else if (st === IssueType.BRK) {
      res = "Broken";
    } else if (st === IssueType.DSC) {
      res = "Disconnected";
    } else if (st === IssueType.NDM) {
      res = "No error detected";
    } else if (st === IssueType.CBOX) {
      res = "Junction box";
    } else if (st === IssueType.IPO) {
      res = "IPO";
    } else if (st === IssueType.DBB) {
      res = "DBB";
    } else if (st === IssueType.DLM) {
      res = "Delamination";
    } else if (st === IssueType.SHC) {
      res = "Short circuit";      
    } else if (st === IssueType.UNK) {
      res = "Unknown";
    } else {
      res = "Unknown id: "+ st;
    }

    return res;
  } 


  public static issueGetRelevance(relevance: string):string {
    let rel = relevance.toUpperCase();
    let relevanceDesc="";
    switch (rel) {
      case "VERYLOW":
        relevanceDesc="Very Low";

        break;        
      case "LOW":
        relevanceDesc="Low";

        break;
      case "MED":
        relevanceDesc="Medium";

        break;        
      case "HIGH":
        relevanceDesc="High";

        break;
      case "VERYHIGH":
        relevanceDesc="Very High";

        break;        
      default:
        relevanceDesc=relevance;    
    }
    return relevanceDesc;
  }
  public static issueGetRelevanceColor(relevance: string):string {
    let rel = relevance.toUpperCase();
    let res="";
    switch (rel) {
      case "VERYLOW":
        res = "#C2B23F";

        break;        
      case "LOW":
        res="#BE883E";

        break;
      case "MED":
        res="#B8613E";

        break;        
      case "HIGH":
        res="#B33E40";

        break;
      case "VERYHIGH":
        res = "#E6012F";

        break;        
      default:
        res="#000";    
    }
    return res;
  }


  public static issueGetIconClass(issueType: any, iconSize:string=''): string {
    
    const st = issueType;
    let res="";
    if (st === 'TOCXS') {
        res= "panel-error-tocxs " + iconSize;
    } else if (st === IssueType.E1PC) {
        res= "panel-error-1pc fas fa-square " + iconSize;           
    } else if (st === IssueType.PCS) {
        res= "panel-error-pcs fas fa-square " + iconSize;  
    } else if (st === IssueType.E1CC) {
        res= "panel-error-1cc fas fa-square " + iconSize;   
    } else if (st === IssueType.CCS) {
        res= "panel-error-ccs fas fa-square " + iconSize; 
    } else if (st === IssueType.SMC) {
        res= "panel-error-smc fas fa-square " + iconSize;      
    } else if (st === IssueType.PID) {
        res= "panel-error-pid fas fa-square " + iconSize;           
    } else if (st === IssueType.DRT) {
        res= "panel-error-drt fas fa-circle " + iconSize;  
    } else if (st === IssueType.SDW) {
        res= "panel-error-sdw fas fa-circle " + iconSize;   
    } else if (st === IssueType.FUS) {
        res= "panel-error-fus fas fa-square " + iconSize; 
    } else if (st === IssueType.BRK) {
        res= "panel-error-brk fas fa-square " + iconSize;             
    } else if (st === IssueType.DSC) {
        res= "panel-error-dsc fas fa-square " + iconSize; 
    } else if (st === IssueType.CBOX) {
        res= "panel-error-cbox fas fa-square " + iconSize;  
    } else if (st === IssueType.DBB) {
        res= "panel-error-unk fas fa-circle " + iconSize;  
    } else if (st === IssueType.DLM) {
        res= "panel-error-unk fas fa-circle " + iconSize; 
    } else if (st === IssueType.SHC) {
        res= "panel-error-unk fas fa-circle " + iconSize;         
    } else if (st === IssueType.IPO) {
        res= "panel-error-unk fas fa-circle " + iconSize;  
    } else if (st === IssueType.UNK) {
        res= "panel-error-unk fas fa-circle " + iconSize;               
    } else if (st === IssueType.NDM) {
        res= "panel-error-ndm fas fa-square " + iconSize;          
    } else {
        res= "";
    }

    //let resi="<i class='panel-error" + res + "'></i>";

    return res;
}
    public static issueGetColorClass(issueType: any): string {
    
    const st = issueType;
    let res="";
    if (st === 'TOCXS') {
        res= "panel-error-tocxs " ;
    } else if (st === IssueType.E1PC) {
        res= "panel-error-1pc " ;           
    } else if (st === IssueType.PCS) {
        res= "panel-error-pcs " ;  
    } else if (st === IssueType.E1CC) {
        res= "panel-error-1cc " ;   
    } else if (st === IssueType.CCS) {
        res= "panel-error-ccs " ; 
    } else if (st === IssueType.SMC) {
        res= "panel-error-smc " ;      
    } else if (st === IssueType.PID) {
        res= "panel-error-pid " ;           
    } else if (st === IssueType.DRT) {
        res= "panel-error-drt " ;  
    } else if (st === IssueType.SDW) {
        res= "panel-error-sdw " ;   
    } else if (st === IssueType.FUS) {
        res= "panel-error-fus " ; 
    } else if (st === IssueType.BRK) {
        res= "panel-error-brk " ;             
    } else if (st === IssueType.DSC) {
        res= "panel-error-dsc " ; 
    } else if (st === IssueType.CBOX) {
        res= "panel-error-cbox " ;  
    } else if (st === IssueType.DBB) {
        res= "panel-error-unk " ;  
    } else if (st === IssueType.DLM) {
        res= "panel-error-unk " ; 
    } else if (st === IssueType.SHC) {
        res= "panel-error-unk " ;         
    } else if (st === IssueType.IPO) {
        res= "panel-error-unk " ;  
    } else if (st === IssueType.UNK) {
        res= "panel-error-unk " ;               
    } else if (st === IssueType.NDM) {
        res= "panel-error-ndm " ;          
    } else {
        res= "";
    }

    //let resi="<i class='panel-error" + res + "'></i>";

    return res;
}
}
